function importAll(r) {
    let images = {};
    r.keys().forEach(i => images[i] = r(i));
    return images;
}
export const images = importAll(require.context('./pics', false, /\.(png|jpe?g|JPG|svg)$/));
